"use client";

import { installNextHistoryMarkerGuard } from "@/lib/next-history-marker";

// Bewusst Modul-Scope statt useEffect: Der Reparatur-Listener muss VOR Nexts
// eigenem popstate-Handler registriert sein (gleiches Event-Target ⇒ es zählt
// die Registrierungsreihenfolge). Nexts Handler wird erst im
// App-Router-Effect registriert, Modul-Code läuft beim Hydration-Start.
installNextHistoryMarkerGuard();

/** Rendert nichts — sorgt nur dafür, dass das Guard-Modul im Root-Bundle lädt. */
export function HistoryMarkerGuard(): null {
  return null;
}
